export type InvoiceSequence =  {
    prefix: string,
    no: number,
    suffix: string,
    uninitialized?: boolean
}

export const uninitializedSequence: InvoiceSequence = {
    prefix: '',
    no: 0,
    suffix: '',
    uninitialized: true
}